import { render, staticRenderFns } from "./BaseModalGallery.vue?vue&type=template&id=4dc2cdb2&"
import script from "./BaseModalGallery.vue?vue&type=script&lang=js&"
export * from "./BaseModalGallery.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_e0fc12eb4d0f55f4cb07c19882e21395/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports